class CaseState {
    constructor(
        id= "",
        name = "",
        workflowStateName = "",
        description = "",
        buttonStyle = "",
        workflowStateIcon = "",
        helpText = "",
        actions = [],
        columns = [],
        selectedWorkflowId,
        caseExpressions = [],
    ) {
        this.id = id;
        this.name = name;
        this.workflowStateName = workflowStateName;
        this.description = description;
        this.buttonStyle = buttonStyle;
        this.workflowStateIcon = workflowStateIcon;
        this.helpText = helpText;
        this.actions = actions;
        this.columns = columns;
        this.selectedWorkflowId = selectedWorkflowId;
        this.caseExpressions = caseExpressions;
    }
}

export default CaseState;